import type { ConsentAction, ConsentState, CookieCategory } from "./types";

export type CookieGuardEventType =
	| "cookieguard:ready"
	| "cookieguard:accept"
	| "cookieguard:reject"
	| "cookieguard:change";

export interface CookieGuardEventDetail {
	consent: ConsentState;
	action: ConsentAction;
	categories: Record<CookieCategory, boolean>;
}

export function emitReady(consent: ConsentState | null): void {
	document.dispatchEvent(new CustomEvent("cookieguard:ready", { detail: { consent } }));
}

export function emitConsent(state: ConsentState): void {
	const detail: CookieGuardEventDetail = {
		consent: state,
		action: state.action,
		categories: {
			necessary: state.necessary,
			functional: state.functional,
			analytics: state.analytics,
			marketing: state.marketing,
		},
	};

	if (state.action === "accept_all") {
		document.dispatchEvent(new CustomEvent("cookieguard:accept", { detail }));
	} else if (state.action === "reject_all") {
		document.dispatchEvent(new CustomEvent("cookieguard:reject", { detail }));
	}

	document.dispatchEvent(new CustomEvent("cookieguard:change", { detail }));
}
